/**
 * Simplified version of Vanilla Toasts JS
 * https://github.com/AlexKvazos/VanillaToasts
 * 
 */
(function (root, factory) {
    try {
        // commonjs
        if (typeof exports === 'object') {
            module.exports = factory();
            // global
        } else {
            root.VanillaToasts = factory();
        }
    } catch (error) {
        console.log('Isomorphic compatibility is not supported at this time for VanillaToasts.')
    }
})(this, function () {

    // We need DOM to be ready
    if (document.readyState === 'complete') {
        init();
    } else {
        window.addEventListener('DOMContentLoaded', init);
    }

    // Create VanillaToasts object
    VanillaToasts = {
        // In case toast creation is attempted before dom has finished loading!
        create: function () {
            console.error([
                'DOM has not finished loading.',
                '\tInvoke create method when DOM\s readyState is complete'
            ].join('\n'))
        },
        toasts: {} // store toasts to modify later
    };

    var autoincrement = 0;

    function init() {
        VanillaToasts.create = function (options) {
            var type = options.type || 'cart-success';
            var image = options.image || undefined;
            var toastTemplate = document.getElementById('toast-template--' + type);
            var toast = toastTemplate.cloneNode(true);

            toast.id = 'toast-' + ++autoincrement;
            toast.classList.remove('animate-toast-out');
            toast.classList.remove('hidden');
            toast.className = toast.className + ' animate-toast-in';
            toast.querySelector('.toast-content').innerHTML = options.text;

            if (image) {
                toast.querySelector('.toast-image').src = image;
            }

            // toast api
            toast.hide = function () {
                toast.className += ' animate-toast-out';
                toast.addEventListener('animationend', function removeToast() {
                    toast.classList.remove('animate-toast-in');
                    document.getElementById('toast-container').removeChild(toast);
                    
                    if (VanillaToasts.toasts[toast.id]) {
                        delete VanillaToasts.toasts[toast.id];  //remove toast from object
                    }
                }, false);
            };

            // click to hide
            toast.querySelector('.toast-dismiss').addEventListener('click', toast.hide);

            // place toast in DOM
            document.getElementById('toast-container').appendChild(toast);

            // store toast
            VanillaToasts.toasts[toast.id] = toast;

            // auto-hide
            setTimeout(toast.hide, 2000);

            return toast;
        }
    }

    return VanillaToasts;

});